<template>
    <div class="relative">
        <button ref="dropdownButton" @click="toggleDropdown" :class="buttonClass"
                class="focus:outline-none font-medium rounded-lg text-xs px-3 py-2 inline-flex items-center">
            <slot name="button">Кнопка</slot>
        </button>
        <div ref="dropdownMenu" v-if="isOpen" :class="menuClass" @click="insideToggleEvent"
             class="absolute z-10 mt-2 border bg-white divide-y divide-gray-100 rounded-lg shadow w-44">
            <slot name="menu">Пусто</slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalSelect",
    props: {
        buttonClass: {
            type: String,
            default: "border border-gray-500 bg-transparent text-black"
        },
        menuClass: {
            type: String,
            default: ""
        },
        insideToggle: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        closeDropdown() {
            this.isOpen = false;
        },
        insideToggleEvent() {
            if (this.insideToggle) {
                this.toggleDropdown()
            }
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.dropdownMenu;
            const button = this.$refs.dropdownButton;

            if (
                dropdown &&
                !dropdown.contains(event.target) &&
                button &&
                !button.contains(event.target)
            ) {
                this.closeDropdown();
            }
        }
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }
};
</script>

<style scoped>
</style>
